module.exports = {
    lcw: require('./lcw'),
    params: require('./params'),
    sections: require('./sections')
}